export default __webpack_public_path__ + "static/media/dropWhite.b66d09f8.svg";